export const ApiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}`;

export const CognitoUserPoolId = `${process.env.REACT_APP_COGNITO_USER_POOL_ID}`;
export const CognitoClientId = `${process.env.REACT_APP_COGNITO_CLIENT_ID}`;
